import { useMediaQuery } from "../use-media-query"

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1440
}

/**
 * A hook that returns whether the current viewport width matches or exceeds a specified breakpoint.
 *
 * @param {('sm'|'md'|'lg'|'xl')} breakpoint - The breakpoint to check against.
 * @returns {boolean} True if the viewport width is greater than or equal to the specified breakpoint, false otherwise.
 *
 * @example
 * ```jsx
 * function ResponsiveComponent() {
 *   const isLargeScreen = useMediaBreakpoint('lg');
 *
 *   return (
 *     <div>
 *       {isLargeScreen ? 'Large Screen Content' : 'Small Screen Content'}
 *     </div>
 *   );
 * }
 */
export function useMediaBreakpoint(breakpoint) {
  if (!breakpoints[breakpoint]) {
    console.error("Invalid breakpoint", breakpoint)
  }

  return useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`)
}
